<template>
  <!-- 多行輸入 -->
  <textarea
    v-if="type === 'text-area'"
    v-model="text"
    :class="['input-textarea', cusClass, errorText ? 'input-error-status' : '', disabled ? 'input-text-disabled' : '']"
    :placeholder="placeholder"
    :disabled="disabled"
    :rows="rows"
    @blur="blur = true"
  ></textarea>
  <!-- 單行輸入 -->
  <input
    v-else
    v-model="text"
    :type="type"
    :class="['input-text', cusClass, errorText ? 'input-error-status' : '', disabled ? 'input-text-disabled' : '']"
    :placeholder="placeholder"
    :disabled="disabled"
    @blur="blur = true"
  />
  <!-- 錯誤小字 -->
  <div v-if="errorText" class="input-error-text">
    <p>{{ errorText }}</p>
  </div>
</template>
<script>
export default {
  name: 'cus-input',
  props: {
    value: { type: undefined },
    type: { type: String, default: 'text' },
    placeholder: { type: String },
    errorText: { type: String, default: '' },
    cusClass: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    rows: { type: Number, default: 4 },
    inputBlur: { type: Boolean, default: false },
  },
  emits: ['update:value', 'update:inputBlur'],
  computed: {
    text: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('update:value', val);
      },
    },
    blur: {
      get() {
        return this.inputBlur;
      },
      set(val) {
        this.$emit('update:inputBlur', val);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.input-text {
  @include input-basic;
  height: $input-height;
  &:focus {
    border: 2px solid $color-blue;
  }
}

.input-textarea {
  @include input-basic;
  padding: 16px;
  &:focus {
    border: 2px solid $color-blue;
  }
}
</style>
